import React from 'react';
import { createRoot } from 'react-dom/client';

import { initializeSentry } from '@paragon/client-tools';
import { attemptAutomaticLogInWithStoredToken, initializeDataConnectionsAndLoginTools } from '@paragon/login-tools';

import ParagonServices from './components/ParagonServices';
import { store } from './store';

initializeSentry();
initializeDataConnectionsAndLoginTools(store);

store.dispatch(attemptAutomaticLogInWithStoredToken());

const root = createRoot(document.querySelector('.root')!);
root.render(<ParagonServices reduxStore={store} />);
